import { useEffect, useState } from 'react'

const useNavbar = () => {
    const [showNavbar, setShowNavbar] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 950)
    const [isInHero, setIsInHero] = useState(true)

    const toggleNavbar = () => {
        const scrollY = window.scrollY;
        
        if (isMobile) {
            // Mobile behavior: 
            // - Show blue navbar at top (0-50px)
            // - Hide navbar in hero section (50px-600px) 
            // - Show white navbar after hero (600px+)
            if (scrollY <= 50) {
                setShowNavbar(true);
                setIsInHero(true);
            } else if (scrollY > 50 && scrollY < 600) {
                setShowNavbar(false);
                setIsInHero(true);
            } else {
                setShowNavbar(true);
                setIsInHero(false);
            }
        } else {
            // Desktop behavior: show after 150px scroll
            setIsInHero(scrollY < 600);
            if(scrollY > 150){
                setShowNavbar(true);
            } else {
                setShowNavbar(false);
            }
        }
    }

    useEffect(()=>{
        const handleResize = () => {
            const mobile = window.innerWidth <= 950;
            setIsMobile(mobile);
        };

        const handleScroll = () => {
            const scrollY = window.scrollY;
            const mobile = window.innerWidth <= 950;
            
            if (mobile) {
                // Mobile behavior
                if (scrollY <= 50) {
                    setShowNavbar(true);
                    setIsInHero(true);
                } else if (scrollY > 50 && scrollY < 600) {
                    setShowNavbar(false);
                    setIsInHero(true);
                } else {
                    setShowNavbar(true);
                    setIsInHero(false);
                }
            } else {
                // Desktop behavior
                setIsInHero(scrollY < 600);
                if(scrollY > 150){
                    setShowNavbar(true);
                } else {
                    setShowNavbar(false);
                }
            }
        };

        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        
        // Initial check
        handleScroll();
        
        //clean up function
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        }
    },[])

  return {showNavbar, isMobile, isInHero}
}

export default useNavbar
